export default "__VITE_PUBLIC_ASSET__9e20211f__"